import { connect } from 'react-redux';
import { isLockedSelector } from 'redux-core/auth/selectors';
import { getLocationSelector } from 'redux-core/router/selectors';

const mapStateToProps = (state) => ({
  locked: isLockedSelector(state),
  location: getLocationSelector(state),
});

export default connect(mapStateToProps);
